import { useMediaQuery } from 'react-responsive';

const useMobileMediaQuery = (fallback?: boolean) => {
  const isMobileByMediaQuery = useMediaQuery({ query: '(max-width: 749px)' });
  if (typeof window !== 'undefined') {
    return isMobileByMediaQuery;
  } else {
    return fallback ?? false;
  }
};

export default useMobileMediaQuery;
